import React from 'react';
import type { FC } from 'react';

interface GridIconProps {
    className?: string;
}

export const GridIcon: FC<GridIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Grid Icon</title>
            <path
                d="M3.40625 4.16732C3.40625 3.9463 3.49405 3.73434 3.65033 3.57806C3.80661 3.42178 4.01857 3.33398 4.23958 3.33398H7.57292C7.79393 3.33398 8.00589 3.42178 8.16217 3.57806C8.31845 3.73434 8.40625 3.9463 8.40625 4.16732V7.50065C8.40625 7.72166 8.31845 7.93363 8.16217 8.08991C8.00589 8.24619 7.79393 8.33398 7.57292 8.33398H4.23958C4.01857 8.33398 3.80661 8.24619 3.65033 8.08991C3.49405 7.93363 3.40625 7.72166 3.40625 7.50065V4.16732Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.7422 4.16732C11.7422 3.9463 11.83 3.73434 11.9863 3.57806C12.1425 3.42178 12.3545 3.33398 12.5755 3.33398H15.9089C16.1299 3.33398 16.3418 3.42178 16.4981 3.57806C16.6544 3.73434 16.7422 3.9463 16.7422 4.16732V7.50065C16.7422 7.72166 16.6544 7.93363 16.4981 8.08991C16.3418 8.24619 16.1299 8.33398 15.9089 8.33398H12.5755C12.3545 8.33398 12.1425 8.24619 11.9863 8.08991C11.83 7.93363 11.7422 7.72166 11.7422 7.50065V4.16732Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.40625 12.4993C3.40625 12.2783 3.49405 12.0664 3.65033 11.9101C3.80661 11.7538 4.01857 11.666 4.23958 11.666H7.57292C7.79393 11.666 8.00589 11.7538 8.16217 11.9101C8.31845 12.0664 8.40625 12.2783 8.40625 12.4993V15.8327C8.40625 16.0537 8.31845 16.2657 8.16217 16.4219C8.00589 16.5782 7.79393 16.666 7.57292 16.666H4.23958C4.01857 16.666 3.80661 16.5782 3.65033 16.4219C3.49405 16.2657 3.40625 16.0537 3.40625 15.8327V12.4993Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.7422 12.4993C11.7422 12.2783 11.83 12.0664 11.9863 11.9101C12.1425 11.7538 12.3545 11.666 12.5755 11.666H15.9089C16.1299 11.666 16.3418 11.7538 16.4981 11.9101C16.6544 12.0664 16.7422 12.2783 16.7422 12.4993V15.8327C16.7422 16.0537 16.6544 16.2657 16.4981 16.4219C16.3418 16.5782 16.1299 16.666 15.9089 16.666H12.5755C12.3545 16.666 12.1425 16.5782 11.9863 16.4219C11.83 16.2657 11.7422 16.0537 11.7422 15.8327V12.4993Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
